import React, { useContext } from 'react';
import { EllipsisOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps } from 'antd';

import TaskContext from '@totem/components/ticketing/details/tasks/taskContext';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { Task } from '@totem/components/ticketing/ticketing';
import { isNotNull } from '@totem/utilities/common';

type Props = {
  task: Task;
};

const NaTaskActionMenu = ({ task }: Props) => {
  const { onAction } = useContext(TicketContext);
  const { taskWorkflow, onTaskStatusChange } = useContext(TaskContext);

  const getStatusChangeMenuOptions = (tsk: Task) => {
    let menuItems: MenuProps['items'] = [];

    const currentStatus = taskWorkflow.find((chk) => chk.code === tsk.status);
    if (isNotNull(currentStatus)) {
      menuItems = currentStatus.options.map((itm) => {
        return {
          key: `key:status_update:${itm}`,
          label: itm,
          title: itm,
        };
      });
    }

    return menuItems;
  };

  const getActionMenuItem = (): MenuProps['items'] => {
    const menuItems: MenuProps['items'] = [
      {
        key: 'updateStatus',
        label: 'Update Status',
        children: getStatusChangeMenuOptions(task),
      },
      {
        key: 'addActivity',
        label: 'Add Activity',
      },
    ];

    return menuItems;
  };

  const onMenuClicked = ({ key }) => {
    if (key.startsWith('key:status_update:')) {
      const newStatus = key.replace('key:status_update:', '');

      onTaskStatusChange(newStatus, task);
      return;
    }
    switch (key) {
      case 'addActivity':
        {
          const extras = { objectReference: { name: 'Task', id: task.id } };
          onAction(
            'show-activity-create',
            extras !== null ? JSON.stringify(extras) : '',
          );
        }
        break;
      default: {
        /* empty */
      }
    }
  };

  return (
    <Dropdown
      menu={{ items: getActionMenuItem(), onClick: onMenuClicked }}
      trigger={['click']}
    >
      <Button shape="circle" icon={<EllipsisOutlined />} />
    </Dropdown>
  );
};

export default NaTaskActionMenu;
